const updateItems = [
  {
    id: 1,
    title: '《逆流而上》大结局收视率破纪录',
    date: '7月31日',
    tag: '热播',
  },
  {
    id: 2,
    title: '站点新增4K超清专区，50+影片已上线',
    date: '7月30日',
    tag: '公告',
  },
  {
    id: 3,
    title: '《星际迷途：新纪元》票房突破30亿',
    date: '7月29日',
    tag: '快讯',
  },
  {
    id: 4,
    title: '90影视APP更新至v3.2.0，新增弹幕功能',
    date: '7月28日',
    tag: '公告',
  },
  {
    id: 5,
    title: '暑期动画专题上线，12部新番同步更新',
    date: '7月26日',
    tag: '上新',
  },
  {
    id: 6,
    title: '《长安十二时辰》续集定档8月15日',
    date: '7月25日',
    tag: '定档',
  },
  {
    id: 7,
    title: '韩剧专区新增50+部高分剧集',
    date: '7月23日',
    tag: '上新',
  },
  {
    id: 8,
    title: '站点CDN全面升级，播放加载速度提升40%',
    date: '7月21日',
    tag: '公告',
  },
  {
    id: 9,
    title: '《迷雾追踪》第三季首支预告片发布',
    date: '7月20日',
    tag: '快讯',
  },
];

export default function UpdatesSection() {
  const tagColors: Record<string, string> = {
    '热播': 'bg-primary-100 text-primary-700',
    '公告': 'bg-accent-100 text-accent-700',
    '快讯': 'bg-secondary-100 text-secondary-700',
    '上新': 'bg-primary-100 text-primary-700',
    '定档': 'bg-accent-100 text-accent-700',
  };

  return (
    <section id="updates" className="py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-8 max-w-[1440px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            最新动态
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-[560px] mx-auto">
            90影视最新影视资讯、站点公告与片单更新动态
          </p>
        </div>

        <div className="max-w-[720px] mx-auto">
          {updateItems.map((item, idx) => (
            <div
              key={item.id}
              className="relative flex gap-4 pb-6 last:pb-0"
            >
              <div className="flex flex-col items-center flex-shrink-0">
                <div className="w-2.5 h-2.5 rounded-full bg-primary-500 mt-1.5"></div>
                {idx < updateItems.length - 1 && (
                  <div className="w-px flex-1 bg-background-200 mt-1.5"></div>
                )}
              </div>
              <div className="flex-1 min-w-0 pb-2">
                <div className="flex flex-wrap items-center gap-2 mb-1">
                  <span className={`px-2 py-0.5 text-[10px] font-medium rounded whitespace-nowrap ${tagColors[item.tag] || 'bg-background-200 text-foreground-600'}`}>
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 leading-snug">
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}